export const iconFontAwesomeHumanitarianPlaneCircleExclamation = (
	<i className="fa-solid fa-plane-circle-exclamation"></i>
);
